import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export default function useGetOrderDetailsDetailsApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const mutation = useMutation<any, Error, {orderId: string; userId: string}>(
    async ({orderId, userId}: {orderId: string; userId: string}) => {
      const response = await ChessRestClient.get(
        'subscription/v1/get_user_order_detail',
        {
          params: {
            order_id: orderId,
            user_id: userId,
          },
        },
      );

      console.log('Csoc Subscription details = ', response.data);
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: error => {
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );

  return mutation;
}
